export default __webpack_public_path__ + "static/media/accounts.174f5227.svg";